var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DocumentSignature',{ref:"sigis-license-agreement",attrs:{"documentKey":_vm.documentKey}})}
var staticRenderFns = []

export { render, staticRenderFns }